let blogFilters = document.querySelectorAll('[data-filter-blog]');

if (blogFilters.length > 0) {
    blogFilters.forEach(async (item) => {
        item.addEventListener("change", (event) => {
            let val = event.target.value;
            let currentSearch = window.location.href.split("/tagged");
            let urlParams = new URLSearchParams(window.location.search);

            if (currentSearch && window.location.href.includes('tagged')) {
                window.location.href = `${currentSearch[0]}/tagged/${val}`;
                if(val == 'all') {
                    window.location.href = `${currentSearch[0]}`;
                }
            }
            else {
                window.location.href = `${window.location.href}/tagged/${val}`;
            }
        });
    });
}